<template>
  <div>
    <apexchart
      width="100%"
      height="500"
      type="treemap"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "OQProducerBasicProductionGraphic",
  components: {
    apexchart: VueApexCharts,
  },
  props: ["series_data_prop", "x_categories_prop"],
  data: function () {
    return {
      series: this.series_data_prop,
      chartOptions: {
        chart: {
          height: 500,
          type: "treemap",
          toolbar: {
            show: true,
          },
        },
        // colors: ["#38B61E", "#DC2626"],
        legend: {
          show: false,
        },
      },
    };
  },
};
</script>
